/***
*
*   APP LAYOUT
*   Main application layout containing the navigation
*   and header (title, secondary nav and signed in user)
*
*   PROPS
*   title: title of the view
*
**********/

import React, { Fragment, useContext } from 'react';
import { AuthContext } from 'components/lib';
import ClassNames from 'classnames';
import Style from './validation.module.scss';
import '../layout.scss'; // globals

export function ValidationLayout(props){

  // context & style
  const context = useContext(AuthContext);
  const css = ClassNames([ Style.app, 'with-sidebar' ]);
  
  return (
    <Fragment>
      <div className= {Style.notifications}>
        <div className={ Style['title-main'] }>
          Deal Finder
        </div>
      </div>
      {/* <AppNav
        type='popup'
        items={[
          { label: 'Dashboard', icon: 'activity', link: '/dashboard' },
          { label: 'Account', icon: 'user', link: '/account', },
          { label: 'Help', icon: 'help-circle', link: '/help' },
          { label: 'Sign Out', icon: 'log-out', action: context.signout }
        ]}
      /> */}
      <main className={ css }>

        { <props.children {...props.data }/> }

      </main>
    </Fragment>
  );
}
